import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {Invoice, InvoicesFilters, InvoiceUI} from '@store/invoices/invoices/invoices.model';
import {GridSortItem} from '@mui/x-data-grid-pro';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface InvoicesState {
  filters: InvoicesFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
  sumNoVatInCents: number;
}

export const invoicesStore = createStore(
  {name: 'invoices'},
  withProps<InvoicesState>({
    filters: {search: '', tableFilters: InvoicesFilters.initTableFilters(), filterAccountantTransferred: false},
    sort: {
      field: 'invoice.createdAt',
      sort: 'desc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
    sumNoVatInCents: 0,
  }),
  withEntities<Invoice>(),
  withUIEntities<InvoiceUI>(),
  withPagination(),
  withRequestsStatus(),
);
